var map = {
	"./clients-financial.svg": 11137,
	"./clients-sales-orders-trips.svg": 35731,
	"./clients-sales-trips.svg": 16835,
	"./clients-sales.svg": 10624,
	"./driver-1.svg": 34554,
	"./driver-car-empty.svg": 58833,
	"./driver-popup-vehicle.svg": 33363,
	"./driver-triangl.svg": 27408,
	"./icons/Expand-all.svg": 16219,
	"./icons/Group.svg": 63008,
	"./icons/LogOut.svg": 89026,
	"./icons/Popup-question.svg": 58649,
	"./icons/Radio.svg": 26515,
	"./icons/Reservation.svg": 98650,
	"./icons/accident-button.svg": 92760,
	"./icons/accordian-icon.svg": 66617,
	"./icons/add-icon.svg": 10716,
	"./icons/alert-circle.svg": 10434,
	"./icons/alert-triangle-icon.svg": 18393,
	"./icons/ap-ar-dark.svg": 57937,
	"./icons/ap-ar.svg": 63559,
	"./icons/approval -popup.svg": 8595,
	"./icons/approve-icon.svg": 55956,
	"./icons/archive-icon.svg": 76588,
	"./icons/arrow-curve-left-up.svg": 90015,
	"./icons/arrow-down-light.svg": 83478,
	"./icons/arrow-down.svg": 85011,
	"./icons/arrow-icon.svg": 76508,
	"./icons/arrow-refresh-icon.svg": 29009,
	"./icons/arrow-right.svg": 18264,
	"./icons/arrows-up.svg": 78458,
	"./icons/bank.svg": 90119,
	"./icons/bell.svg": 80204,
	"./icons/branch-icon.svg": 20037,
	"./icons/bread_crumb.svg": 66056,
	"./icons/bread_crumb_double.svg": 97441,
	"./icons/calendar-01.svg": 22538,
	"./icons/calendar-03.svg": 91810,
	"./icons/calendar-icon.svg": 60034,
	"./icons/calendar.svg": 64674,
	"./icons/car-icon.svg": 47877,
	"./icons/change-status.svg": 87373,
	"./icons/charter-icon.svg": 58356,
	"./icons/check-black-icon.svg": 65102,
	"./icons/check-broken.svg": 26743,
	"./icons/check-icon.svg": 8798,
	"./icons/chevron-down-blue.svg": 50849,
	"./icons/chevron-down.svg": 43886,
	"./icons/chevron.svg": 58136,
	"./icons/client-dark.svg": 51544,
	"./icons/client-edit.svg": 75488,
	"./icons/client-info-icon.svg": 76157,
	"./icons/client.svg": 17928,
	"./icons/clock-1-icon.svg": 2821,
	"./icons/clock-2-icon.svg": 64998,
	"./icons/clock-icon.svg": 40011,
	"./icons/clock.svg": 23826,
	"./icons/close-icon.svg": 11570,
	"./icons/closed-popup.svg": 47274,
	"./icons/column-vertical.svg": 90398,
	"./icons/company-detail.svg": 19631,
	"./icons/company-details.svg": 4576,
	"./icons/company-profile-dark.svg": 86802,
	"./icons/company-profile.svg": 16997,
	"./icons/confirm-with-note-icon.svg": 88904,
	"./icons/contract-icon.svg": 28499,
	"./icons/cross-icon-light.svg": 54772,
	"./icons/cross-icon.svg": 20575,
	"./icons/cycle-icon.svg": 38668,
	"./icons/dashboard-dark.svg": 13896,
	"./icons/dashboard.svg": 60118,
	"./icons/delete-category.svg": 43298,
	"./icons/download-02.svg": 57494,
	"./icons/download-icon.svg": 69512,
	"./icons/driver-edit.svg": 14154,
	"./icons/driver-info-icon.svg": 5741,
	"./icons/driver-picture-dummy-1.svg": 34340,
	"./icons/driver-picture-dummy.svg": 64905,
	"./icons/driver-remove-x.svg": 35294,
	"./icons/driver-vehicle.svg": 47789,
	"./icons/dry-clean-button.svg": 26614,
	"./icons/edit-button.svg": 74537,
	"./icons/edit-panicle.svg": 87790,
	"./icons/edit-pen-custom.svg": 10952,
	"./icons/edit-pen.svg": 96448,
	"./icons/escalation.svg": 16515,
	"./icons/excel-icon.svg": 54939,
	"./icons/exclamation-mark.svg": 19866,
	"./icons/export-icon.svg": 90737,
	"./icons/file-1-icon.svg": 59913,
	"./icons/file-attach.svg": 39627,
	"./icons/file-icon.svg": 9462,
	"./icons/finance-icon-dark.svg": 63073,
	"./icons/finance-icon.svg": 79608,
	"./icons/form-builder.svg": 52905,
	"./icons/funnel-simple.svg": 1107,
	"./icons/grid-icon.svg": 69339,
	"./icons/image-icon.svg": 68406,
	"./icons/image-placeholder.svg": 67391,
	"./icons/import.svg": 47013,
	"./icons/information-circle-blue.svg": 39169,
	"./icons/insurance-button.svg": 6654,
	"./icons/license-renewal-button.svg": 82463,
	"./icons/list-icon.svg": 44084,
	"./icons/location-icon.svg": 32991,
	"./icons/maintenance-Button.svg": 45510,
	"./icons/maintenance-vector.svg": 55092,
	"./icons/management-system.svg": 96517,
	"./icons/map.svg": 74156,
	"./icons/message-square.svg": 58340,
	"./icons/messaging-center-icon-light.svg": 50764,
	"./icons/messaging-center-icon.svg": 32295,
	"./icons/minus-circle-contained.svg": 61282,
	"./icons/more-details.svg": 66532,
	"./icons/move.svg": 4746,
	"./icons/my-profile-dark.svg": 69812,
	"./icons/my-profile.svg": 27027,
	"./icons/new-list-icon.svg": 21061,
	"./icons/operations.svg": 73481,
	"./icons/paperclip-files.svg": 67219,
	"./icons/pdf-icon.svg": 1404,
	"./icons/person-vector.svg": 6836,
	"./icons/phone-call.svg": 1230,
	"./icons/pin-marker.svg": 24834,
	"./icons/pincle-edit-light.svg": 51380,
	"./icons/pincle-edit.svg": 65403,
	"./icons/placeholder-add.svg": 4603,
	"./icons/placeholder-location.svg": 2929,
	"./icons/plus-danger.svg": 26165,
	"./icons/plus-icon.svg": 90484,
	"./icons/plus-secondary.svg": 91909,
	"./icons/plus-white.svg": 59513,
	"./icons/plus.svg": 74132,
	"./icons/popup-cancel-icon.svg": 92119,
	"./icons/popup-close.svg": 81446,
	"./icons/popup-info-wide-icon.svg": 85158,
	"./icons/popup-success-icon-new.svg": 42682,
	"./icons/popup-success-icon.svg": 3138,
	"./icons/popup-warning-icon.svg": 46461,
	"./icons/printer.svg": 16152,
	"./icons/recurrence-icon.svg": 6266,
	"./icons/rejected-icon.svg": 14837,
	"./icons/renewal-Button.svg": 86359,
	"./icons/requests-icon-dark.svg": 39336,
	"./icons/requests-icon.svg": 13703,
	"./icons/returned-icon.svg": 56231,
	"./icons/sales-icon-dark.svg": 44055,
	"./icons/sales-icon-light.svg": 63626,
	"./icons/search-bar-icon.svg": 22715,
	"./icons/search-color-icon.svg": 80262,
	"./icons/search-icon.svg": 10598,
	"./icons/select-time.svg": 13577,
	"./icons/setting-icon-dark.svg": 11199,
	"./icons/setting-icon-light.svg": 49300,
	"./icons/setting-icon.svg": 11664,
	"./icons/shift-recurring-icon.svg": 32021,
	"./icons/small-face-dark.svg": 98518,
	"./icons/small-face.svg": 14484,
	"./icons/small-truck.svg": 73713,
	"./icons/sort-ascending.svg": 79571,
	"./icons/sort-descending.svg": 22912,
	"./icons/star.svg": 24281,
	"./icons/start-marker.svg": 53751,
	"./icons/step-shape.svg": 44678,
	"./icons/switch-dark.svg": 33132,
	"./icons/switch-outline.svg": 47395,
	"./icons/system-management-dark.svg": 19468,
	"./icons/ticket-button.svg": 12955,
	"./icons/ticket-timer.svg": 75555,
	"./icons/tickets-person.svg": 62855,
	"./icons/tickets-timer-circle.svg": 51989,
	"./icons/transfer-button.svg": 47583,
	"./icons/trash-icon-red.svg": 71446,
	"./icons/trash-icon.svg": 11537,
	"./icons/trash-light-new.svg": 66554,
	"./icons/trash-red-icon.svg": 51286,
	"./icons/truck-icon.svg": 60290,
	"./icons/trush-light.svg": 98610,
	"./icons/trush.svg": 14486,
	"./icons/upload-icon.svg": 73078,
	"./icons/user-icon.svg": 26290,
	"./icons/user-profile.svg": 51086,
	"./icons/vehicle-picture-dummy.svg": 56281,
	"./icons/warning-alert.svg": 31895,
	"./icons/x-circle-contained.svg": 23407,
	"./universal.svg": 30434
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 29866;